import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { titleize, unescapeHTML } from 'underscore.string';
import { withTranslation, Translation } from 'react-i18next';
import { DropdownButton, MenuItem, Badge, Pagination } from 'react-bootstrap';
import _ from 'underscore';
import { cloneDeep } from 'lodash';
import CargomaticCard from 'components/v2/card';
import CargomaticBadge from 'components/v2/Badge';
import AddButton from 'components/v2/buttons/AddButton';
import { massUpdateActions } from 'constants/MassUpdates';
import OrdersActionCreators from 'actions/OrdersActionCreators';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import EquipmentActionCreators from 'actions/EquipmentActionCreators';
import OrderShipmentsStore from 'stores/OrderShipmentsStore';
import { updateOrder } from 'utils/OrderWebAPIUtils';
import EditEquipmentModal from 'components/modules/equipment/EditEquipmentModal';
import SendDOEmailModal from 'components/modules/shipments/SendDOEmailModal';
import BulkEditModal from 'components/modules/shipments/MassUpdateModal';
import BulkUpdateSendDOModal from 'components/modules/shipments/BulkUpdateSendDOModal';
import BulkUpdateCarrierCostModal from 'components/modules/shipments/BulkUpdateCarrierCostModal';
import ChangeUserModal from 'components/modules/shipments/ChangeUserModal';
import SessionStore from 'stores/SessionStore';
import TripFormStore from 'stores/TripFormStore';
import { sluggify } from 'utils/localization/utils';
import { Disclosure } from '@headlessui/react';
import { createShipment } from './CreateShipment';
import ManageStagingItem from './ManageStagingItem';
import RemoveShipmentModal from './RemoveShipmentModal';
import { isIntermodalShipmentType } from '../../../helpers/shipment-types';
import TripPlannerModal from '../shipments/TripPlannerModal';
import GenerateTripModal from '../shipments/trips/GenerateTripModal';
import { getDeliveryOrderRecipients } from '../../../helpers/shipments';
import BulkBookingForm from '../booking/BulkBookingForm';
import { getDocumentsV2, getSignedUrl } from '../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../stores/ToastStore';
import ConfirmAssignCarrierModal from '../shipments/ConfirmAssignCarrierModal';
const mapStagingShipmentItem = (shipment) => (Object.assign(Object.assign({}, shipment), { deliveryOrderGenerating: false, editRow: false, expanded: false }));
const mapShipmentItem = (shipment) => (Object.assign(Object.assign({}, shipment), { deliveryOrderGenerating: false, editRow: false, expanded: false }));
class ShipmentsList extends Component {
    constructor(props) {
        super(props);
        this.getSelectedShipments = () => {
            const { selected } = this.state;
            return this.state.shipments.filter((s) => selected.includes(s._id));
        };
        this.handleShowBulkBookingForm = () => this.setState({ showBulkBookingFormModal: true });
        this.handleHideBulkBookingForm = () => this.setState({ showBulkBookingFormModal: false });
        this.handleBulkBookingSuccess = () => {
            setTimeout(() => {
                this.handleHideBulkBookingForm();
            }, 2000);
            this.props.onGetPaginatedShipments(1);
        };
        this.handleTripAppliedEvent = () => {
            const context = TripFormStore.getTripContext();
            const { formStatus: { completed, success }, } = context;
            if (completed && success) {
                this.props.onGetPaginatedShipments(1);
            }
        };
        this.handleStagingShipmentsChange = (stagingShipments = []) => {
            this.updateStagingShipmentsState(stagingShipments.map(mapStagingShipmentItem));
        };
        this.updateStagingShipmentsState = (nextStagingShipments) => {
            this.setState((prevState) => {
                const stagingShipments = nextStagingShipments.reduce((runningList, stagedShipment) => {
                    const isExpanded = prevState.expanded.includes(stagedShipment._id);
                    if (isExpanded) {
                        const expandedRow = cloneDeep(stagedShipment);
                        expandedRow.editRow = true;
                        expandedRow.expanded = true;
                        return runningList.concat([stagedShipment, expandedRow]);
                    }
                    return runningList.concat(stagedShipment);
                }, []);
                const shipments = [...stagingShipments, ...prevState.bookedShipments];
                const updatedShipmentListState = getShipmentListState(shipments, prevState);
                const stagingShipmentsLoaded = true;
                return Object.assign(Object.assign({ stagingShipments,
                    shipments }, updatedShipmentListState), { stagingShipmentsLoaded });
            });
        };
        this.handleOrderShipmentsStoreChange = () => {
            const { bookedShipments } = this.state;
            this.updateShipmentsState(bookedShipments.map(mapShipmentItem));
        };
        this.handleOrderShipmentCreation = (type) => {
            // Can't create a shipment while a request is in progress. When it's done the type will be 'SUCCEEDED' or 'FAILED'.
            const disableCreateShipment = type === 'REQUESTED';
            this.setState({ disableCreateShipment });
        };
        this.handleRemoveShipment = (selectedShipment) => this.setState({
            showRemoveModal: true,
            selectedShipment,
        });
        this.closeEquipmentModal = () => {
            this.setState({
                showEditEquipmentModal: false,
                selectedEquipment: null,
            });
        };
        this.isShipmentExpanded = (id) => this.state.expanded.includes(id);
        this.isShipmentSelected = (id) => this.state.selected.includes(id);
        this.handleEditEquipment = (selectedEquipment) => this.setState({
            showEditEquipmentModal: true,
            selectedEquipment,
        });
        this.handleSelectAllChange = (e) => {
            const { target: { checked: selectAll }, } = e;
            this.setState((prevState) => {
                const { shipments } = prevState;
                let selected = [];
                if (selectAll) {
                    selected = shipments.map((s) => s._id);
                }
                return {
                    selected,
                    selectAll,
                };
            });
        };
        this.handleSelectRowChange = (_id, checked) => {
            this.setState((prevState) => {
                const { shipments, selected: currentSelected } = prevState;
                let selected;
                if (checked) {
                    selected = [...currentSelected, _id];
                }
                else {
                    const index = currentSelected.findIndex((s) => s === _id);
                    selected = [
                        ...currentSelected.slice(0, index),
                        ...currentSelected.slice(index + 1),
                    ];
                }
                const selectAll = selected.length === shipments.length;
                return {
                    selectAll,
                    selected,
                };
            });
        };
        this.handleToggleExpand = (id, toggled) => {
            this.setState((prevState) => {
                const { shipments: currentShipments, expanded: currentExpanded } = prevState;
                let expanded;
                const shipmentIndex = currentShipments.findIndex((s) => s._id === id && !s.editRow);
                const summaryRow = currentShipments[shipmentIndex];
                let editRow;
                const editRowIndex = currentShipments.findIndex((s) => s._id === id && s.editRow);
                let shipments;
                if (editRowIndex !== -1) {
                    editRow = cloneDeep(currentShipments[editRowIndex]);
                    shipments = [
                        ...currentShipments.slice(0, shipmentIndex),
                        summaryRow,
                        editRow,
                        ...currentShipments.slice(shipmentIndex + 2),
                    ];
                }
                else {
                    editRow = cloneDeep(summaryRow);
                    shipments = [
                        ...currentShipments.slice(0, shipmentIndex),
                        summaryRow,
                        editRow,
                        ...currentShipments.slice(shipmentIndex + 1),
                    ];
                }
                editRow.editRow = true;
                if (toggled) {
                    expanded = [...currentExpanded, id];
                    editRow.expanded = true;
                }
                else {
                    editRow.expanded = false;
                    expanded = [
                        ...currentExpanded.slice(0, shipmentIndex),
                        ...currentExpanded.slice(shipmentIndex + 1),
                    ];
                }
                return {
                    expanded,
                    shipments,
                };
            });
        };
        this.handleSaveEquipment = (equipment) => {
            EquipmentActionCreators.updateEquipment(equipment);
            // For Staging shipments, equipments are on the stop level. Stops in the stops array of
            // ShipmentStagingSchema aren't mapped to Mongo ids, so they don't get re-populated
            // when changes are made to an individual equipment item. The following obviously isn't
            // ideal, but with the current architecture it's the only way to make sure that equipments
            // attached to a stop in Shipment Staging get updated when their properties change.
            // We need to go through all the Staging shipments because the same piece of equipment
            // can be on multiple ones.
            if (!_.isEmpty(this.props.order.shipments_staging)) {
                const stagingShipmentsToUpdate = this.props.order.shipments_staging.map((shipment) => {
                    shipment.stops = shipment.stops.map((stop) => {
                        stop.equipments = stop.equipments.map((eq) => {
                            if (eq._id === equipment._id) {
                                return equipment;
                            }
                            return eq;
                        });
                        return stop;
                    });
                    return shipment;
                });
                updateOrder(this.props.order._id, {
                    shipments_staging: stagingShipmentsToUpdate,
                });
            }
        };
        this.handleCloseGenerateTripModal = () => {
            this.setState({
                selected: [],
                selectAll: false,
                showGenerateTripModal: false,
            });
        };
        this.handleShowGenerateTripModal = () => {
            this.setState({ showGenerateTripModal: true });
        };
        this.handleShowTripPlannerModal = () => {
            this.setState({ showTripPlannerModal: true });
        };
        this.handleCloseTripPlannerModal = () => {
            this.setState({ showTripPlannerModal: false });
        };
        this.onHideBulkEditModal = () => this.setState({ showBulkEditModal: false });
        this.getDeliveryOrderRecipient = () => {
            const recipient = '';
            if (this.state.selectedShipment) {
                const shipment = this.state.shipments.filter((s) => s._id === this.state.selectedShipment);
                if (shipment.length) {
                    return getDeliveryOrderRecipients(shipment[0].carrier);
                }
            }
            return recipient;
        };
        this.handleSendDeliveryOrder = (selectedShipment) => this.setState({ showSendEmailModal: true, selectedShipment });
        this.handleGenerateDeliveryOrder = (jobId) => {
            this.setState((currentState) => {
                const { shipments: currentShipments } = currentState;
                const index = currentShipments.findIndex((j) => j._id === jobId);
                if (index === -1) {
                    return null;
                }
                const shipment = cloneDeep(currentShipments[index]);
                shipment.generateDeliveryOrder = true;
                const shipments = [
                    ...currentShipments.slice(0, index),
                    shipment,
                    ...currentShipments.slice(index + 1),
                ];
                return {
                    shipments,
                };
            }, () => OrdersActionCreators.generateDeliveryOrder(jobId));
        };
        this.handleBulkActionMenu = (bulkAction) => {
            switch (bulkAction) {
                case massUpdateActions.CHANGE_CARRIER:
                    this.setState({
                        bulkAction,
                        showChangeCarrierModal: true,
                    });
                    break;
                case massUpdateActions.SEND_DELIVERY_ORDER:
                    this.setState({
                        bulkAction,
                        showBulkUpdateSendDoModal: true,
                    });
                    break;
                case massUpdateActions.UPDATE_CARRIER_COST:
                    this.setState({
                        bulkAction,
                        showBulkUpdateCarrierCostModal: true,
                    });
                    break;
                default:
                    this.setState({
                        bulkAction,
                        showBulkEditModal: true,
                    });
                    break;
            }
        };
        this.renderTripPlannerButtons = () => {
            if (!SessionStore.hasTripPlannerRole()) {
                return [];
            }
            const { t } = this.props;
            return [
                React.createElement("button", { key: "create-trip-button", type: "button", className: "mb-4 rounded-full sm:mb-0 button button-hollow-green", onClick: this.handleShowTripPlannerModal }, t('PLAN_A_TRIP')),
                React.createElement("button", { key: "generate-trip-button", type: "button", className: "mb-4 rounded-full sm:mb-0 button button-hollow-green", disabled: this.generateTripDisabled(), onClick: this.handleShowGenerateTripModal }, t('GENERATE_A_TRIP')),
            ];
        };
        this.renderBulkActionsButton = () => {
            return [this.renderBulkActionMenu()];
        };
        this.renderShipmentActions = () => {
            return [
                ...this.renderTripPlannerButtons(),
                ...this.renderBulkBookingButton(),
                ...this.renderBulkActionsButton(),
            ];
        };
        this.onPaginationSelect = (eventKey) => this.props.onGetPaginatedShipments(eventKey);
        this.state = {
            accountingHold: false,
            showSendEmailModal: false,
            showTripPlannerModal: false,
            showGenerateTripModal: false,
            showBulkBookingFormModal: false,
            showRemoveModal: false,
            showEditEquipmentModal: false,
            selectedShipment: null,
            selectedEquipment: null,
            bookedShipmentsLoaded: false,
            stagingShipmentsLoaded: false,
            expanded: [],
            selected: [],
            selectAll: false,
            stagingShipments: props.stagingShipments,
            shipments: [],
            bookedShipments: props.bookedShipments,
            disableCreateShipment: false,
            paginationData: props.paginationData,
        };
    }
    componentDidMount() {
        OrderShipmentsStore.addShipmentCreationListener(this.handleOrderShipmentCreation);
        TripFormStore.addTripAppliedEventListener(this.handleTripAppliedEvent);
        this.handleOrderShipmentsStoreChange();
        this.handleStagingShipmentsChange();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const accountingHold = nextProps.order.shipper && nextProps.order.shipper.accounting
            ? nextProps.order.shipper.accounting.on_hold
            : false;
        this.setState({ accountingHold });
        if (this.props.order._id !== nextProps.order._id) {
            this.props.onGetPaginatedShipments(1);
            this.handleStagingShipmentsChange(nextProps.stagingShipments);
        }
        if (this.props.bookedShipments !== nextProps.bookedShipments) {
            this.updateShipmentsState(nextProps.bookedShipments);
        }
        if (this.props.stagingShipments !== nextProps.stagingShipments) {
            this.handleStagingShipmentsChange(nextProps.stagingShipments);
        }
        if (this.props.paginationData !== nextProps.paginationData) {
            this.setState({ paginationData: nextProps.paginationData });
        }
    }
    componentWillUnmount() {
        OrderShipmentsStore.removeShipmentCreationListener(this.handleOrderShipmentCreation);
        TripFormStore.removeTripAppliedEventListener(this.handleTripAppliedEvent);
    }
    generateTripDisabled() {
        return this.state.selected.length === 0;
    }
    updateShipmentsState(bookedShipments) {
        this.setState((prevState) => {
            const { stagingShipments } = prevState;
            const shipments = [...stagingShipments, ...bookedShipments];
            const updatedShipmentListState = getShipmentListState(shipments, prevState);
            const bookedShipmentsLoaded = true;
            return Object.assign(Object.assign({}, updatedShipmentListState), { bookedShipments,
                bookedShipmentsLoaded,
                shipments });
        });
    }
    sendEmail() {
        return (emails) => {
            ShipmentsActionCreators.sendDeliveryOrder(this.state.selectedShipment, emails);
        };
    }
    renderBulkActionMenu() {
        const { t } = this.props;
        return (React.createElement(DropdownButton, { id: "bulk-actions-dropdown", className: "mb-4 sm:mb-0", disabled: !this.state.selected.length || this.props.renderedInModal, title: t('BULK_ACTIONS'), onSelect: this.handleBulkActionMenu, bsStyle: "danger" },
            React.createElement(MenuItem, { eventKey: massUpdateActions.UPDATE_APPOINTMENT_WINDOW }, t('UPDATE_APPOINTMENT_WINDOW')),
            React.createElement(MenuItem, { eventKey: massUpdateActions.EDIT_DISCHARGE }, t('UPDATE_DISCHARGE')),
            React.createElement(MenuItem, { eventKey: massUpdateActions.EDIT_LAST_FREE_DAY }, t('UPDATE_LFD')),
            React.createElement(MenuItem, { eventKey: massUpdateActions.CHANGE_CARRIER }, t('ASSIGN_CARRIER')),
            React.createElement(MenuItem, { eventKey: massUpdateActions.UPDATE_CARRIER_COST }, titleize(t('UPDATE_CARRIER_COST'))),
            React.createElement(MenuItem, { eventKey: massUpdateActions.SEND_DELIVERY_ORDER }, t('SEND_DO'))));
    }
    renderHeaderRow() {
        const { t } = this.props;
        return (React.createElement("tr", { className: "border-b border-solid border-grey bg-grey-lightest" },
            React.createElement("th", { className: "p-4" },
                React.createElement("input", { type: "checkbox", checked: this.state.selectAll, onChange: this.handleSelectAllChange })),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker" }, t('ID')),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker", style: { width: '120px' } }, t('STATUS')),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker", style: { width: '210px' } }, t('BILLING_STATUS')),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker" }, t('EQUIPMENT_ID')),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker", style: { width: '200px' } }, titleize(t('PICKUP'))),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker", style: { width: '200px' } }, titleize(t('DELIVER'))),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker" }, titleize(t('CARRIER'))),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker" }, t('DELIVERY_ORDER')),
            React.createElement("th", { className: "p-4 text-sm font-bold text-grey-darker" }, "\u00A0")));
    }
    renderShipments() {
        const { bookedShipmentsLoaded, stagingShipmentsLoaded, shipments } = this.state;
        const { t } = this.props;
        if (!bookedShipmentsLoaded && !stagingShipmentsLoaded) {
            return (React.createElement("tr", null,
                React.createElement("td", { colSpan: "6", className: "p-2" },
                    React.createElement("i", { className: "mr-2 fa fa-spin fa-circle-o-notch" }),
                    t('LOADING_SHIPMENTS'),
                    "...")));
        }
        if (shipments.length === 0) {
            return (React.createElement("tr", null,
                React.createElement("td", { colSpan: "6", className: "p-2" },
                    React.createElement("h4", { className: "text-base text-grey-dark" }, t('NO_SHIPMENTS_CLICK_TO_ADD_MORE')))));
        }
        return this.state.shipments.map((shipment) => (React.createElement(OrderShipment, { order: this.props.order, shipment: shipment, selected: this.isShipmentSelected(shipment._id), expanded: this.isShipmentExpanded(shipment._id), onSelectRowChange: this.handleSelectRowChange, onEditEquipment: this.handleEditEquipment, onGenerateDeliveryOrder: this.handleGenerateDeliveryOrder, onSendDeliveryOrder: this.handleSendDeliveryOrder, onRemoveShipment: this.handleRemoveShipment, onToggleExpand: this.handleToggleExpand, key: getKey(shipment) })));
    }
    renderBulkBookingButton() {
        const { t } = this.props;
        const button = (React.createElement("button", { className: "mb-4 rounded-full sm:mb-0 button button-hollow-green", onClick: this.handleShowBulkBookingForm }, t('BOOK_MULTIPLE_SHIPMENTS')));
        return [button];
    }
    renderPagination() {
        const { paginationData } = this.state;
        const items = (paginationData && paginationData.totalPages) || 1;
        const activePage = (paginationData && paginationData.currentPage) || 1;
        return (React.createElement(Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true, items: items, maxButtons: 5, activePage: activePage, onSelect: this.onPaginationSelect }));
    }
    render() {
        var _a, _b, _c, _d;
        const { order: { carrier: orderCarrier }, t, } = this.props;
        const shipperId = ((_b = (_a = this.props.order) === null || _a === void 0 ? void 0 : _a.shipper) === null || _b === void 0 ? void 0 : _b._id) || ((_d = (_c = this.props.order) === null || _c === void 0 ? void 0 : _c.shipper) === null || _d === void 0 ? void 0 : _d.id);
        const defaultDeliveryOrderRecipient = this.getDeliveryOrderRecipient();
        const carrierAuthorized = orderCarrier && orderCarrier.authorized;
        const carrier = carrierAuthorized ? orderCarrier : null;
        return (React.createElement(CargomaticCard, { removeHorizontalPadding: true, removeVerticalPadding: true, header: () => (React.createElement("div", { className: "flex flex-wrap justify-between" },
                React.createElement("div", { className: "flex items-center mb-4 sm:mb-0 space-x-2" },
                    React.createElement("div", { className: "flex items-center" },
                        React.createElement("h3", { className: "my-0" }, titleize(t('SHIPMENT', { count: 2 }))),
                        this.state.accountingHold && (React.createElement(CargomaticBadge, { color: "red", className: "ml-1" }, t('ACCOUNT_ON_HOLD')))),
                    React.createElement(AddButton, { id: "order-add-shipment-button", className: "shipment-shipmentsList-addShipmentForDrayage heap", onClick: () => {
                            createShipment(this.props, {
                                shipment_type: 'drayage',
                                no_equipment: true,
                            });
                        }, disabled: this.state.accountingHold || this.state.disableCreateShipment })),
                React.createElement("div", { className: "flex flex-wrap items-start space-x-2" }, this.renderShipmentActions()))) },
            this.state.showGenerateTripModal && (React.createElement(GenerateTripModal, { show: this.state.showGenerateTripModal, onClose: this.handleCloseGenerateTripModal, onGenerateTrip: this.handleGenerateTrip, orderId: this.props.order._id, shipments: this.getSelectedShipments() })),
            this.state.showTripPlannerModal && (React.createElement(TripPlannerModal, { show: this.state.showTripPlannerModal, onClose: this.handleCloseTripPlannerModal, shipperId: shipperId, orderId: this.props.order._id, carrier: carrier, equipments: this.props.order.equipments })),
            this.state.showRemoveModal && (React.createElement(RemoveShipmentModal, { show: this.state.showRemoveModal, onClose: () => {
                    this.setState({
                        showRemoveModal: false,
                        selectedShipment: null,
                    });
                }, order: this.props.order, _id: this.state.selectedShipment })),
            this.state.showEditEquipmentModal && (React.createElement(EditEquipmentModal, { show: this.state.showEditEquipmentModal, onHide: this.closeEquipmentModal, equipment: this.state.selectedEquipment, onSave: this.handleSaveEquipment })),
            this.state.showBulkEditModal && (React.createElement(BulkEditModal, { show: true, action: this.state.bulkAction, onHide: this.onHideBulkEditModal, shipments: this.state.selected, origin: this.props.order.arriving[0], destination: this.props.order.delivering[0] })),
            this.state.showChangeCarrierModal && (React.createElement(ChangeUserModal, { jobs: this.getSelectedShipments(), show: this.state.showChangeCarrierModal, type: "carrier", onSave: ShipmentsActionCreators.updateCarrier, onAssignBrokerCarrier: (shipment, driver) => this.setState({
                    showConfirmAssignCarrierModal: true,
                    showChangeCarrierModal: false,
                    brokerCarrierDriver: driver,
                }), onHide: () => this.setState({ showChangeCarrierModal: false }) })),
            React.createElement(ConfirmAssignCarrierModal, { isOpen: this.state.showConfirmAssignCarrierModal, brokerCarrierDriver: this.state.brokerCarrierDriver, shipment: this.getSelectedShipments(), onConfirm: (shipments, carrier) => {
                    ShipmentsActionCreators.updateCarrier(carrier, shipments);
                }, onClose: () => this.setState({ showConfirmAssignCarrierModal: false }) }),
            this.state.showBulkUpdateCarrierCostModal && (React.createElement(BulkUpdateCarrierCostModal, { title: t('UPDATE_CARRIER_COSTS'), show: this.state.showBulkUpdateCarrierCostModal, shipments: this.state.selected, onHide: () => {
                    this.setState({ showBulkUpdateCarrierCostModal: false });
                } })),
            this.state.showBulkUpdateSendDoModal && (React.createElement(BulkUpdateSendDOModal, { title: titleize(t('SEND_DELIVERY_ORDER')), send_do: this.state.bulkAction === massUpdateActions.SEND_DELIVERY_ORDER, show: this.state.showBulkUpdateSendDoModal, shipments: this.state.selected, onHide: () => this.setState({ showBulkUpdateSendDoModal: false }) })),
            React.createElement("div", { className: "" },
                React.createElement("table", { className: "w-full mb-6 border-collapse" },
                    React.createElement("thead", null, this.renderHeaderRow()),
                    React.createElement("tbody", null, this.renderShipments())),
                React.createElement("div", { className: "flex flex-row-reverse pr-6" }, this.renderPagination())),
            this.state.showSendEmailModal && (React.createElement(SendDOEmailModal, { show: this.state.showSendEmailModal, onSend: this.sendEmail(), onHide: () => this.setState({ showSendEmailModal: false }), defaultRecipient: defaultDeliveryOrderRecipient })),
            this.state.showBulkBookingFormModal && (React.createElement(BulkBookingForm, { orderId: this.props.order._id, order: this.props.order, show: this.state.showBulkBookingFormModal, onHide: this.handleHideBulkBookingForm, onSaveSuccess: this.handleBulkBookingSuccess, origin: this.props.order.arriving[0], destination: this.props.order.delivering[0], shipperId: shipperId, carrier: carrier }))));
    }
}
ShipmentsList.propTypes = {
    order: PropTypes.object,
    renderedInModal: PropTypes.bool,
};
class OrderShipment extends Component {
    constructor() {
        super(...arguments);
        this.handleGenerateDeliveryOrder = (shipmentId) => this.props.onGenerateDeliveryOrder(shipmentId);
        this.handleSendDeliveryOrder = (shipmentId) => this.props.onSendDeliveryOrder(shipmentId);
        this.handleToggleExpand = () => this.props.onToggleExpand(this.props.shipment._id, !this.props.expanded);
        this.handleRemoveShipment = () => this.props.onRemoveShipment(this.props.shipment._id);
        this.handleEditEquipment = (equipmentId) => {
            const { shipment: { equipments }, } = this.props;
            const equipment = equipments.find((eq) => eq._id === equipmentId);
            this.props.onEditEquipment(equipment);
        };
        this.handleCheckboxChange = (e) => {
            const { target: { checked }, } = e;
            const { shipment: { _id }, } = this.props;
            this.props.onSelectRowChange(_id, checked);
        };
        this.handleCancelEdit = () => this.props.onToggleExpand(this.props.shipment._id, false);
    }
    renderActions() {
        const { shipment } = this.props;
        const { isStaging } = shipment;
        if (isStaging) {
            return (React.createElement(StagingActions, { onRemoveShipment: this.handleRemoveShipment, onToggleExpand: this.handleToggleExpand }));
        }
        return (React.createElement(ManageButton, { shipment: shipment, onGenerateDeliveryOrder: this.handleGenerateDeliveryOrder, onSendDeliveryOrder: this.handleSendDeliveryOrder }));
    }
    renderRow() {
        const { selected, shipment } = this.props;
        const { status, billing_status } = shipment;
        return (React.createElement(Disclosure, { as: "tr" },
            React.createElement("td", { className: "p-4" },
                React.createElement("input", { type: "checkbox", checked: selected, onChange: this.handleCheckboxChange })),
            React.createElement("td", { className: "p-4" }, formatId(shipment)),
            React.createElement("td", { className: "p-4" }, formatStatus(status)),
            React.createElement("td", { className: "p-4" }, formatBillingStatus(billing_status)),
            React.createElement("td", { className: "p-4" },
                React.createElement(EquipmentsColumn, { equipments: shipment.equipments, onEditEquipment: this.handleEditEquipment })),
            React.createElement("td", { className: "p-4" }, formatLocation(shipment.pickup)),
            React.createElement("td", { className: "p-4" }, formatLocation(shipment.deliver)),
            React.createElement("td", { className: "p-4" }, formatCarrier(shipment)),
            React.createElement("td", { className: "p-4" },
                React.createElement(DeliveryOrderColumnWithLocalization, { shipment: shipment })),
            React.createElement("td", { className: "p-4" }, this.renderActions())));
    }
    renderExpandedRow() {
        const { order, shipment } = this.props;
        return (React.createElement("tr", null,
            React.createElement("td", { colSpan: "10" },
                React.createElement(ManageStagingItem, { order: order, shipment: shipment, cancelEditing: this.handleCancelEdit }))));
    }
    render() {
        const { shipment: { editRow }, expanded, } = this.props;
        if (editRow) {
            return expanded ? this.renderExpandedRow() : null;
        }
        return this.renderRow();
    }
}
OrderShipment.propTypes = {
    onEditEquipment: PropTypes.func.isRequired,
    onGenerateDeliveryOrder: PropTypes.func.isRequired,
    onSendDeliveryOrder: PropTypes.func.isRequired,
    onRemoveShipment: PropTypes.func.isRequired,
    onSelectRowChange: PropTypes.func.isRequired,
    onToggleExpand: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    order: PropTypes.object.isRequired,
    shipment: PropTypes.shape({
        isStaging: PropTypes.bool.isRequired,
        _id: PropTypes.string.isRequired,
    }).isRequired,
    expanded: PropTypes.bool,
};
OrderShipment.defaultProps = {
    selected: false,
    expanded: false,
};
function getKey(shipment) {
    const { isStaging, _id, editRow } = shipment;
    const rowTypeLabel = editRow ? 'expanded' : 'summary';
    return `shipment-${_id}-${isStaging}-${rowTypeLabel}`;
}
function formatId(shipment) {
    const { isStaging, shipment_id } = shipment;
    if (isStaging) {
        return null;
    }
    const link = `/shipments/${shipment._id}`;
    return (React.createElement("a", { href: link, target: "_blank", rel: "noopener noreferrer" }, shipment_id));
}
function formatCarrier(shipment) {
    const { carrier } = shipment;
    if (!carrier) {
        return null;
    }
    const carrierId = carrier._id ? carrier._id : carrier;
    const link = `/users/${carrierId}`;
    return (React.createElement("a", { href: link, target: "_blank", rel: "noopener noreferrer" }, unescapeHTML(carrier.name)));
}
const colors = {
    available: 'bg-green',
    unavailable: 'bg-red-500',
    'In Progress': 'bg-teal-400',
    accepted: 'bg-green',
    'Awaiting Booking': 'bg-purple-500',
};
function formatStatus(cell) {
    const bg = colors[cell] || 'bg-green';
    const classNames = classnames({
        'p-1': true,
        rounded: true,
        [bg]: true,
        'text-white': true,
        'text-sm': true,
        'font-bold': true,
    });
    return (React.createElement(Translation, null, (t) => React.createElement("span", { className: classNames }, t(sluggify(cell)))));
}
function formatBillingStatus(cell) {
    const bg = 'bg-green';
    const classNames = classnames({
        'p-2': true,
        rounded: true,
        [bg]: true,
        'text-white': true,
        'text-sm': true,
        'font-bold': true,
    });
    return (React.createElement(Translation, null, (t) => React.createElement("span", { className: classNames }, titleize(t(sluggify(cell))))));
}
function formatLocation(cell) {
    if (!cell) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("div", null, cell.name && (React.createElement("label", { className: "mr-2 text-sm font-bold text-grey-darker" }, unescapeHTML(cell.name)))),
        React.createElement("span", { className: "mb-4" }, cell.address)));
}
class DeliveryOrderColumn extends Component {
    constructor() {
        super(...arguments);
        this.openDeliveryOrder = (shipment) => async (event) => {
            var _a, _b, _c;
            const { t } = this.props;
            event.preventDefault();
            const { data, errors: documentErrors } = await getDocumentsV2([shipment._id], 'delivery_order', {
                order: {
                    field: 'createdAt',
                    direction: 'desc',
                },
                limit: 1,
            });
            if (documentErrors) {
                showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', {
                    error: documentErrors[0].message,
                }), 'error');
                return;
            }
            if (((_b = (_a = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                const { data: signedUrl, errors: signedUrlErrors } = await getSignedUrl(data.getDocumentsV2.documents[0].key);
                if (signedUrlErrors) {
                    showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                        error: signedUrlErrors[0].message,
                    }), 'error');
                    return;
                }
                if ((_c = signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.getSignedUrl) === null || _c === void 0 ? void 0 : _c.signedUrl) {
                    const delivery_order_signed_link = signedUrl.getSignedUrl.signedUrl;
                    window.open(delivery_order_signed_link, 'new');
                }
            }
        };
    }
    render() {
        const { shipment } = this.props;
        const { generateDeliveryOrder, delivery_order_sent, carrier } = shipment;
        if (!carrier) {
            return null;
        }
        const badgeStyle = {
            position: 'absolute',
            top: '-5px',
            right: '-20px',
            background: 'red',
            fontSize: '9px',
        };
        return (React.createElement(Translation, null, (t) => (React.createElement("div", null,
            generateDeliveryOrder && (React.createElement("button", { disabled: true, className: "button" },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("i", { className: "mr-2 fa fa-circle-o-notch fa-spin" }),
                    React.createElement("span", null,
                        titleize(t('UPDATING')),
                        "...")))),
            !generateDeliveryOrder && (React.createElement("div", null,
                React.createElement("a", { href: "#", title: "Delivery Order", className: "relative items-start button button-green", onClick: this.openDeliveryOrder(shipment) },
                    React.createElement("span", null, titleize(t('DOWNLOAD'))),
                    delivery_order_sent && (React.createElement(Badge, { style: badgeStyle }, t('SENT'))))))))));
    }
}
DeliveryOrderColumn.propTypes = {
    shipment: PropTypes.object.isRequired,
};
const DeliveryOrderColumnWithLocalization = withTranslation()(DeliveryOrderColumn);
class EquipmentsColumn extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = (equipmentId) => (e) => {
            e.preventDefault();
            this.props.onEditEquipment(equipmentId);
        };
    }
    render() {
        const { equipments } = this.props;
        if (!equipments || equipments.length === 0) {
            return null;
        }
        return (React.createElement("div", null, equipments.map((equipment) => (React.createElement("a", { key: equipment._id, href: "#", className: "block mb-2", onClick: this.handleClick(equipment._id) }, equipment.equipment_id)))));
    }
}
EquipmentsColumn.propTypes = {
    equipments: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        equipment_id: PropTypes.string,
    })),
    onEditEquipment: PropTypes.func.isRequired,
};
EquipmentsColumn.defaultProps = {
    equipments: [],
};
class ManageButton extends Component {
    constructor() {
        super(...arguments);
        this.handleSelect = (key) => {
            const { shipment: { _id }, } = this.props;
            if (key === 'view') {
                const link = `/shipments/${_id}`;
                window.open(link, '_blank');
            }
            else if (key === 'generate-delivery-order') {
                this.props.onGenerateDeliveryOrder(_id);
            }
            else if (key === 'email-delivery-order') {
                this.props.onSendDeliveryOrder(_id);
            }
        };
    }
    render() {
        const { shipment } = this.props;
        const { _id, carrier } = shipment;
        const buttonId = `manage-shipment-${_id}`;
        return (React.createElement(Translation, null, (t) => (React.createElement(DropdownButton, { id: buttonId, title: t('MANAGE'), style: {
                backgroundColor: 'white',
                color: '#25AA82',
                borderColor: '#25AA82',
                fontSize: '.875rem',
                fontWeight: '700',
                borderRadius: '.25rem',
            }, onSelect: this.handleSelect },
            carrier && isIntermodalShipmentType(shipment) && (React.createElement(MenuItem, { eventKey: "email-delivery-order", style: { fontSize: '.875rem' } }, t('EMAIL_DELIVERY_ORDER'))),
            carrier && (React.createElement(MenuItem, { eventKey: "generate-delivery-order", style: { fontSize: '.875rem' } }, t('GENERATE_DELIVERY_ORDER'))),
            React.createElement(MenuItem, { eventKey: "view", style: { fontSize: '.875rem' } }, t('VIEW_DETAILS'))))));
    }
}
ManageButton.propTypes = {
    shipment: PropTypes.shape({
        _id: PropTypes.string,
    }),
    onGenerateDeliveryOrder: PropTypes.func.isRequired,
    onSendDeliveryOrder: PropTypes.func.isRequired,
};
class StagingActions extends Component {
    constructor() {
        super(...arguments);
        this.handleToggleExpand = () => this.props.onToggleExpand();
        this.handleRemoveShipment = () => this.props.onRemoveShipment();
    }
    render() {
        return (React.createElement(Translation, null, (t) => (React.createElement("div", { className: "flex flex-row" },
            React.createElement(Disclosure.Button, { className: "mr-2 text-white button bg-blue-cm hover:bg-blue-cm-darker", onClick: this.handleToggleExpand }, titleize(t('EDIT'))),
            React.createElement("button", { className: "text-white button bg-grey-dark hover:bg-grey-darker", onClick: this.handleRemoveShipment },
                React.createElement("i", { className: "fa fa-trash-o" }))))));
    }
}
StagingActions.propTypes = {
    onRemoveShipment: PropTypes.func.isRequired,
    onToggleExpand: PropTypes.func.isRequired,
};
function getShipmentListState(shipments, prevState) {
    const shipmentIds = shipments.map((s) => s._id);
    const selected = prevState.selected.filter((id) => shipmentIds.includes(id));
    const expanded = prevState.expanded.filter((id) => shipmentIds.includes(id));
    const selectAll = selected.length === shipmentIds.length;
    return {
        selected,
        expanded,
        selectAll,
    };
}
export default withTranslation()(ShipmentsList);
